import type { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import SolutionsPage from "../pages/solutions/page";
import InfrastructurePage from "../pages/infrastructure/page";
import SecurityPage from "../pages/security/page";
import CaseStudiesPage from "../pages/case-studies/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/solutions",
    element: <SolutionsPage />,
  },
  {
    path: "/infrastructure",
    element: <InfrastructurePage />,
  },
  {
    path: "/security",
    element: <SecurityPage />,
  },
  {
    path: "/case-studies",
    element: <CaseStudiesPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
